// src/components/Login.js
import React from "react";
import {
  GoogleOAuthProvider,
  GoogleLogin,
  googleLogout,
} from "@react-oauth/google";
import { clientId } from "./googleAuthConfig";
import { jwtDecode } from "jwt-decode";

const Login = () => {
  const handleLoginSuccess = (credentialResponse) => {
    const decodedToken = jwtDecode(credentialResponse.credential);
    // You can store the user info in state or context
  };

  const handleLoginFailure = (error) => {
    console.error("Login failed: ", error);
  };

  const handleLogout = () => {
    googleLogout();
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div>
        <h2>Google Authentication</h2>
        <GoogleLogin
          onSuccess={handleLoginSuccess}
          onError={handleLoginFailure}
        />
        <button onClick={handleLogout}>Logout</button>
      </div>
    </GoogleOAuthProvider>
  );
};

export default Login;
